var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlaceassisesvert = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.54,
    height: 18.271,
    viewBox: "0 0 11.54 18.271",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "places-assises",
    transform: "translate(-3571.229 -5914.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_221",
    "data-name": "Groupe 221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_217",
    "data-name": "Groupe 217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_274552",
    "data-name": 274552,
    transform: "translate(3571.229 5914.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_92",
    "data-name": "Groupe 92",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_91",
    "data-name": "Groupe 91",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M65.939,110.52a1.923,1.923,0,1,0-1.923-1.923A1.923,1.923,0,0,0,65.939,110.52Z",
    transform: "translate(-61.13 -106.674)",
    fill: "#91c450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M7.213,243.352H2.79l-1.84-8.278a.481.481,0,1,0-.94.209l1.912,8.6v2.832a.481.481,0,0,0,.962,0v-2.4H5.769v2.4a.481.481,0,0,0,.962,0v-2.4h.481a.481.481,0,0,0,0-.962Z",
    transform: "translate(0 -228.928)",
    fill: "#91c450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M71.227,219.111H67.861v-3.846a1.923,1.923,0,0,0-3.846,0v5.289A1.444,1.444,0,0,0,65.457,222h4.327v3.366a1.442,1.442,0,0,0,2.885,0v-4.808A1.444,1.444,0,0,0,71.227,219.111Z",
    transform: "translate(-61.129 -208.533)",
    fill: "#91c450"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlaceassisesvert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/placeassisesvert.9677322d.svg";
export { ForwardRef as ReactComponent };